import { zIndex } from 'src/components/css'

/**
 * The layer the roster modals must stack above, or `undefined` on the page.
 *
 * In full screen the tab is a `position: fixed` shell at `zIndex.overlay`. The
 * roster editor (`RosterPlayerModal`) normally sits on the page's own low layer,
 * inset below the nav, and the Add Player search is an antd modal at antd's
 * default 1000 — both UNDER the shell, so they opened invisibly behind it. Both
 * take this as `hostZIndex` and go one layer above it, the same mechanism
 * SN-8449 uses for the Team Budget sheet.
 */
export const fullscreenModalHostZIndex = (
  isFullscreen: boolean
): number | undefined => (isFullscreen ? zIndex.overlay : undefined)
